import { OrganizationEntitlementRevokedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/organization_events_pb';
import { Col } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

type OrganizationEntitlementRevokedDetailProps = {
  event: OrganizationEntitlementRevokedEvent;
};

export const OrganizationEntitlementRevokedDetail = ({
  event,
}: OrganizationEntitlementRevokedDetailProps) => {
  const organization = event.organization;

  if (!organization) {
    return (
      <Col className="@OrganizationEntitlementRevokedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@OrganizationEntitlementRevokedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Organization Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={organization.id?.value} />
          <FieldDisplay label="Name" value={organization.name} />
        </div>
      </Col>

      <Col
        className="rounded-md border border-warning/20 bg-warning/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-warning/80">
          Entitlement Revoked
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <FieldDisplay label="Entitlement" value={event.entitlement} />
        </div>
      </Col>
    </Col>
  );
};
